import ConsultationTypes, {
  ConsultationTypeName,
} from '../types/ConsultationTypes'

export function getMediumValue(medium?: ConsultationTypeName) {
  if (!medium) return 'None'
  return ConsultationTypes[medium]
}
